export const tipologieFase = {
	presentazione_domande: 'PRESENTAZIONE_DOMANDE',
	istruttoria: 'ISTRUTTORIA',
	secondo_accesso_non_ammessi_sospesi: 'SECONDO_ACCESSO_NON_AMMESSI_SOSPESI',
	terzo_accesso_sospesi: 'TERZO_ACCESSO_SOSPESI',
	aggiornamento_isee: 'AGGIORNAMENTO_ISEE',
	rettifica_iban: 'RETTIFICA_IBAN',
	riapertura_presentazione: 'RIAPERTURA_PRESENTAZIONE',
	annullamento_domande: 'ANNULLAMENTO_DOMANDE'
}
